import React from 'react';

interface StatusItem {
  label: string;
  isValid: boolean;
  value: string;
  warning?: string;
}

interface StatusSummaryProps {
  title?: string;
  items: StatusItem[];
}

export const StatusSummary: React.FC<StatusSummaryProps> = ({
  title = 'Ready to Process:',
  items
}) => {
  return (
    <div style={{ 
      padding: '12px', 
      backgroundColor: '#fafafa', 
      border: '1px solid #d9d9d9', 
      borderRadius: '6px',
      fontSize: '14px'
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>{title}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {items.map((item, index) => (
          <div key={index} style={{ color: item.isValid ? '#52c41a' : '#ff4d4f' }}>
            ✓ {item.label}: {item.value}
            {item.warning && <span style={{ color: '#fa8c16' }}> {item.warning}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

